import '../views/footer.css'
import '../style.css'
import { getOpeningStatus } from '../utils/openingHours'
import HoursBadge from './HoursBadge'
import { useAnnouncement } from '../context/AnnouncementContext'
import { Link } from "react-router-dom";

const Footer = ({ menu }) => {

  const openingHours = menu?.openingHours ?? {}
  const onlineOrderHours = menu?.onlineOrderHours ?? {}

  const {
    openDays,
    onlineOrderDays,
    announcementActive
  } = useAnnouncement()

  const {
    isOpen,
    isOnlineOrderOpen
  } = getOpeningStatus(new Date(), {
    openDays,
    onlineOrderDays,
    openingHours,
    onlineOrderHours
  })

  const status =
    announcementActive
      ? 'closed-temp'
      : isOpen && isOnlineOrderOpen
        ? 'open-full'
        : isOpen
          ? 'open-physical-only'
          : 'closed'

  const dotOpen =
    status !== 'closed' && status !== 'closed-temp'

  const effectiveLabel =
    status === 'closed-temp'
      ? 'Fermée temporairement'
      : status === 'open-full'
        ? 'Ouvert • commande en ligne'
        : status === 'open-physical-only'
          ? 'Ouvert (sur place uniquement)'
          : 'Fermé'

  return (
    <footer className="footer-root">
      <div className="footer-inner">

        {/* Brand */}
        <div className="footer-column footer-brand">
          <h3 className="footer-brand-title">
            La Friterie de Lalaing
          </h3>

          <p className="footer-brand-tagline">
            Frites croustillantes et spécialités belges au cœur d'Écaussinnes-Lalaing.
          </p>

          <HoursBadge
            dotOpen={dotOpen}
            effectiveLabel={effectiveLabel}
          />
        </div>

        {/* Informations */}
        <div className="footer-column footer-contact">
          <h4 className="footer-column-title">
            Informations
          </h4>

          <ul className="footer-list">

            <li>
              <a href="tel:067339939">
                067 33 99 39
              </a>
            </li>

            <li>
              <a
                href="mailto:lalaing@abjmnets.com"
              >
                lalaing@abjmnets.com
              </a>
            </li>

            <li>
              <a
                href="https://www.google.com/maps/place/Friterie+de+Lalaing/"
                target="_blank"
                rel="noreferrer"
              >
                Rue de la Grande Ronce 7
                <br />
                7190 Écaussinnes
              </a>
            </li>

          </ul>
        </div>

        {/* Horaires */}
        <div className="footer-column footer-hours">

          <h4 className="footer-column-title">
            Horaires
          </h4>

          <ul className="footer-list">

            <li>Mercredi – Dimanche : 17h30 – 21h00</li>

            <li>Lundi – Mardi : fermé</li>

            <li>Commande en ligne :
              <br />
              Mer., Jeu. & Sam.
              jusqu'à 20h20
            </li>

          </ul>

        </div>

        {/* Navigation */}
        <div className="footer-column footer-links">

          <h4 className="footer-column-title">
            Découvrir
          </h4>

          <ul className="footer-list">

            <li>
              <a href="/menu">
                Notre menu
              </a>
            </li>

            <li>
              <a href="/patrimoine">
                Notre histoire
              </a>
            </li>

            <li>
              <a
                href="https://www.google.com/maps/place/Friterie+de+Lalaing/@50.5694873,4.1751398,17z/data=!4m8!3m7!1s0x47c2357a38ceaa6d:0x83fba363582b0fec!8m2!3d50.5694839!4d4.1777147!9m1!1b1!16s%2Fg%2F1tm11rz0?entry=ttu&g_ep=EgoyMDI2MDYyOS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noreferrer"
              >
                Avis Google
              </a>
            </li>

          </ul>

        </div>

        {/* Légal */}
        <div className="footer-column footer-legal">

          <h4 className="footer-column-title">
            Légal
          </h4>
          <p className="footer-legal-text">
            Consultez nos informations légales et notre politique de confidentialité.
          </p>
          <ul className="footer-list">

            <li>

              <Link to="/mentions-legales">
                Mentions légales
              </Link>
            </li>

            <li>

              <Link to="/confidentialite">
                Confidentialité
              </Link>
            </li>

            <li>
              <Link to="/Conditions">
                Conditions de commande
              </Link>
            </li>

          </ul>

        </div>

      </div>

      <div className="footer-bottom">

        <span>
          © {new Date().getFullYear()} La Friterie de Lalaing
        </span>

        <span>
          BCE : 0898.575.732
        </span>

        <span>
          TVA : BE0898.575.732
        </span>

        <span>
          Site conçu par{" "}
          <a
            href="https://gaetancrabeels.com"
            target="_blank"
            rel="noreferrer"
          >
            Gaëtan Crabeels
          </a>
        </span>

      </div>

    </footer>
  )
}

export default Footer